import { useEffect, useState } from 'react';

/** Ile milisekund zostało do najbliższej północy czasu lokalnego. */
export function msToNextDay(now) {
  // Północ z kalendarza, nie „+24 h”: w dniu zmiany czasu doba ma 23 albo 25 godzin.
  const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return next.getTime() - now.getTime();
}

const sameDay = (a, b) => a.getFullYear() === b.getFullYear()
  && a.getMonth() === b.getMonth()
  && a.getDate() === b.getDate();

/**
 * Dzisiejszy dzień, który zmienia się sam o północy.
 *
 * `new Date()` wołane w renderze pokazuje dzień ostatniego renderu: panel zostawiony na noc
 * przy ladzie rano nadal pokazywał wczorajszą datę. Hook przerysowuje komponent o północy,
 * a po powrocie do karty sprawdza dzień jeszcze raz, bo uśpiona karta nie odlicza czasu.
 * W obrębie jednego dnia zwraca ten sam obiekt.
 */
export default function useToday() {
  const [today, setToday] = useState(() => new Date());

  useEffect(() => {
    let timer;
    const refresh = () => setToday((prev) => {
      const now = new Date();
      return sameDay(prev, now) ? prev : now;
    });
    const schedule = () => {
      // Sekunda zapasu: zegar odpalony o ułamek za wcześnie trafiłby jeszcze w stary dzień.
      timer = setTimeout(() => { refresh(); schedule(); }, msToNextDay(new Date()) + 1000);
    };
    schedule();

    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return today;
}
